module.exports = __webpack_public_path__ + "img/DNADamage-OVCA_10X_OC.7562878f.png";